import http from 'hub-http/clients/apiClient';
import { mapContentData } from 'personalization-lib/utils/assetData/content';
export const fetchContentById = ({
  url,
  id
}) => http.get(`${url}/${id}`).then(mapContentData);
export const fetchContentByIds = async ({
  url,
  ids
}) => {
  const contentUrl = `${url}?id__in=${ids.join(',')}&limit=${ids.length}`;
  const {
    objects
  } = await http.get(contentUrl);
  return objects.map(mapContentData);
};